import * as UUID from 'uuid';
import baseX from 'base-x';
const ServerOwnerSID = 'server';
const ServerOwnerUUID = '00000000-0000-0000-0000-000ba8b512e1';
const ServerOwnerUint8Arr = new Uint8Array([
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    11,
    168,
    181,
    18,
    225,
]);
const Base62 = baseX('0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz');
export class DomainId {
    constructor(prefix, sid) {
        this.prefix = prefix;
        // The sid provided has a prefix, compare with the expected prefix and set the id.
        if (sid && sid.includes('_')) {
            const [sidPrefix, sidId] = sid.split('_');
            if (prefix !== sidPrefix) {
                console.warn(`Given prefix (${prefix}) and sid prefix (${sidPrefix}) do not match, ignoring for now, but be warned!`);
            }
            this._id = this.fromString(sidId);
        }
        else if (sid && !sid.includes('_')) {
            this._id = this.fromString(sid);
        }
        else {
            this._id = this.generate();
        }
    }
    get id() {
        return Base62.encode(this._id[0].subarray(this._id[1]));
    }
    /**
     * Converts this DomainId to string format *prefix_Base62*.
     */
    toString() {
        return `${this.prefix}_${this.id}`;
    }
    /**
     * Converts this DomainId to UUID format *00000000-0000-0000-0000-000000000000*. Prefix is ignored.
     */
    toUUID() {
        if (this.id === ServerOwnerSID || this._id[0] === ServerOwnerUint8Arr) {
            return ServerOwnerUUID;
        }
        try {
            return UUID.stringify(this._id[0]);
        }
        catch (e) {
            console.log('Invalid id?', this._id);
            return '';
        }
    }
    /**
     * Compares another DomainId object with this one, returning true if they have the same id and false if they do not.
     *
     * @param b DomainId object to be compared with this.
     * @param ignorePrefix If set to true, will return true whether or not the prefixes match. Defaults to false.
     */
    compare(b, ignorePrefix = false) {
        return this.id === b.id && (ignorePrefix === true || this.prefix === b.prefix);
    }
    /**
     * Converts a Base62 encoded or UUID string value to a
     *
     * @param sid Either a Base62 encoded string or UUID string.
     */
    fromString(sid) {
        let buffer;
        if (sid === ServerOwnerUUID || sid === ServerOwnerSID) {
            buffer = ServerOwnerUint8Arr;
        }
        else if (UUID.validate(sid)) {
            buffer = new Uint8Array(UUID.parse(sid));
        }
        else {
            try {
                buffer = new Uint8Array(Base62.decode(sid));
            }
            catch (e) {
                throw new Error('Invalid sid, neither UUID nor Base62 encoded string');
            }
        }
        // Build the 16 element Uint8Array
        const array = new Uint8Array(16);
        if (buffer.length === 16) {
            array.set(buffer);
        }
        else if (buffer.length < 16) {
            array.set(buffer, 16 - buffer.length);
        }
        else if (buffer.length > 16) {
            array.set(buffer.slice(-16, buffer.length));
        }
        // Calculate offset from beginning to first non-zero.
        let offset = 0;
        while (array[offset] === 0) {
            offset++;
        }
        return [array, offset];
    }
    /**
     * Generates a new random UUID v4.
     */
    generate() {
        const buffer = new Uint8Array(16);
        UUID.v4({}, buffer);
        let offset = 0;
        while (buffer[offset] === 0) {
            offset++;
        }
        return [buffer, offset];
    }
}
//# sourceMappingURL=domain_id.js.map